/**
 * @generated SignedSource<<ecd3ecbd46175020efcc7016346bd26c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileUserSummary_org$data = {
  readonly id: string;
  readonly experiments: ReadonlyArray<string | null> | null;
  readonly personsByCalendarIdsErrorable: {
    readonly __typename: "PersonList";
    readonly list: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly emails: ReadonlyArray<string>;
      readonly primaryEmail: string;
      readonly profile: {
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
      } | null;
      readonly isYou: boolean;
      readonly isUser: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"CalendarStatus_person">;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly calendarStatusErrorable: {
    readonly __typename: "CalendarStatus";
    readonly " $fragmentSpreads": FragmentRefs<"CalendarStatus_calendarStatus">;
  } | {
    readonly __typename: "GraphEntityError";
    readonly message: string | null;
    readonly statusCode: number | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly profileTimeZonesErrorable: {
    readonly __typename: "ProfileTimeZoneList";
    readonly list: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"CalendarStatus_profileTimeZone">;
    }>;
  } | {
    readonly __typename: "GraphEntityError";
    readonly message: string | null;
    readonly statusCode: number | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly collaboratorStatsErrorable: {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
  } | {
    readonly __typename: "CollaboratorStats";
    readonly calendarId: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly suggestedInvites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly targetCalendarId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly pendingInvites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly targetCalendarId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProfileUserSummary_org";
};
export type ProfileUserSummary_org$key = {
  readonly " $data"?: ProfileUserSummary_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileUserSummary_org">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "calendarIds",
    "variableName": "calendarIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "calendarId",
  "variableName": "calendarId"
},
v4 = {
  "kind": "Variable",
  "name": "timeZone",
  "variableName": "timeZone"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusCode",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetCalendarId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "calendarId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "calendarIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "rangeMax"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "rangeMin"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "timeZone"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileUserSummary_org",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "experiments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": null,
      "kind": "LinkedField",
      "name": "personsByCalendarIdsErrorable",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "list",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CalendarStatus_person"
                },
                (v2/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emails",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "primaryEmail",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "profile",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "givenName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "familyName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalImageUrl",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isYou",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isUser",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PersonList",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "calendarStatusErrorable",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CalendarStatus_calendarStatus"
            }
          ],
          "type": "CalendarStatus",
          "abstractKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": null,
      "kind": "LinkedField",
      "name": "profileTimeZonesErrorable",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileTimeZone",
              "kind": "LinkedField",
              "name": "list",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CalendarStatus_profileTimeZone"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ProfileTimeZoneList",
          "abstractKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v3/*: any*/),
        {
          "kind": "Variable",
          "name": "rangeMax",
          "variableName": "rangeMax"
        },
        {
          "kind": "Variable",
          "name": "rangeMin",
          "variableName": "rangeMin"
        },
        (v4/*: any*/)
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "collaboratorStatsErrorable",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v5/*: any*/)
          ],
          "type": "GraphEntityError",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "calendarId",
              "storageKey": null
            }
          ],
          "type": "CollaboratorStats",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v7/*: any*/),
      "concreteType": "SuggestedOrgInviteConnection",
      "kind": "LinkedField",
      "name": "suggestedInvites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SuggestedOrgInviteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SuggestedOrgInvite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "suggestedInvites(first:1000000)"
    },
    {
      "alias": null,
      "args": (v7/*: any*/),
      "concreteType": "OrgInviteConnection",
      "kind": "LinkedField",
      "name": "pendingInvites",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgInviteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgInvite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v8/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "pendingInvites(first:1000000)"
    }
  ],
  "type": "Org",
  "abstractKey": null
};
})();

(node as any).hash = "b3c53553aafa3b80586f04c43691742d";

export default node;
